/**
 * SM_004: keep utm_campaign in sync with the Campaign ID field.
 *
 * Create Link auto-fills utm_campaign from the Campaign ID, but the value stays
 * user-editable. The rule, applied whenever Campaign ID changes:
 *   - Campaign ID set   → set utm_campaign to it, UNLESS the user has diverged
 *     utm_campaign from the last auto-synced value (then leave their value alone).
 *   - Campaign ID cleared → REMOVE utm_campaign, but only if it still equals the
 *     last synced value (`prevCampaignId`); a hand-edited utm_campaign is kept.
 *
 * Without the clear branch, deleting the Campaign ID left a stale utm_campaign
 * (e.g. the last un-deleted character "P") saved on the link. Pure.
 *
 * @param params          current UTM map
 * @param prevCampaignId  the previous (already-trimmed) Campaign ID value
 * @param currentCampaignId the new Campaign ID (trimmed internally)
 */
export function syncUtmCampaign(
  params: Record<string, string>,
  prevCampaignId: string,
  currentCampaignId: string,
): Record<string, string> {
  const curr = (currentCampaignId || '').trim();

  if (!curr) {
    if (params.utm_campaign !== undefined && params.utm_campaign === prevCampaignId) {
      const { utm_campaign, ...rest } = params;
      return rest;
    }
    return params;
  }

  if (!params.utm_campaign || params.utm_campaign === prevCampaignId) {
    return { ...params, utm_campaign: curr };
  }
  return params;
}
